import { TIKTOK_COMMENTS_PROMPT } from '../prompts/tiktok-comments';

export function buildTikTokCommentsContext(): string {
    return `\n\n${TIKTOK_COMMENTS_PROMPT}`;
}
